module.exports = __webpack_public_path__ + "img/little-symmetry-neutral.86ff9583.svg";